import copy from 'clipboard-copy';

export default function copyToClipboard(value) {
    copy(value);
}
